export default "__VITE_ASSET__fff4df29__"